import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Section } from "./Section";
import { FINAL_CTA } from "@/content/landing";

export function FinalCTA() {
  return (
    <Section bare testId="landing-final-cta">
      <div className="relative overflow-hidden rounded-3xl border border-border/60 bg-card/60 px-8 py-16 text-center sm:px-12 sm:py-20">
        <div
          aria-hidden="true"
          className="pointer-events-none absolute inset-0 opacity-30"
          style={{
            background:
              "radial-gradient(60% 60% at 50% 0%, hsl(var(--accent) / 0.25), transparent 70%)",
          }}
        />
        <div className="relative">
          <p className="mb-4 inline-flex items-center gap-2 rounded-full border border-border/60 bg-background/60 px-3 py-1 font-mono text-[11px] uppercase tracking-[0.22em] text-muted-foreground backdrop-blur">
            <span className="inline-block h-1.5 w-1.5 rounded-full bg-accent" />
            {FINAL_CTA.eyebrow}
          </p>
          <h2 className="mx-auto max-w-2xl text-3xl font-semibold tracking-tight text-foreground sm:text-4xl lg:text-5xl">
            {FINAL_CTA.title}
          </h2>
          <p className="mx-auto mt-5 max-w-xl text-base leading-relaxed text-muted-foreground sm:text-lg">
            {FINAL_CTA.subtitle}
          </p>
          <div className="mt-9 flex flex-col items-center justify-center gap-3 sm:flex-row">
            <Link to={FINAL_CTA.primaryCta.href}>
              <Button
                data-testid="landing-final-cta-primary"
                size="lg"
                className="group h-12 rounded-full sema-cta-gradient px-6 font-mono text-xs uppercase tracking-[0.22em] text-white shadow-lg shadow-sema-primary/30 transition-transform hover:-translate-y-0.5"
              >
                {FINAL_CTA.primaryCta.label}
                <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-0.5" />
              </Button>
            </Link>
            <Link to={FINAL_CTA.secondaryCta.href}>
              <Button
                data-testid="landing-final-cta-secondary"
                variant="outline"
                size="lg"
                className="h-12 rounded-full border-border/80 px-6 font-mono text-xs uppercase tracking-[0.22em] text-foreground hover:bg-muted"
              >
                {FINAL_CTA.secondaryCta.label}
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </Section>
  );
}
